import { useState, useEffect } from 'react';
import { message } from 'antd';

export const useSpaceVisual = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedFloor, setSelectedFloor] = useState<string>('');
  const [loading, setLoading] = useState(false);

  // 模拟数据加载
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setSelectedFloor('1');
      setLoading(false);
    }, 1000);
  }, []);

  // 处理刷新
  const handleRefresh = () => {
    setLoading(true);
    message.success('数据已刷新');
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  // 处理全屏
  const handleFullscreen = () => {
    message.info('全屏功能开发中...');
  };

  // 处理设置
  const handleSettings = () => {
    message.info('设置功能开发中...');
  };

  return {
    activeTab,
    setActiveTab,
    selectedFloor,
    setSelectedFloor,
    loading,
    handleRefresh,
    handleFullscreen,
    handleSettings
  };
};
